import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer" 
            onClick={() => {
              navigate('/');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <div className="flex items-center space-x-2">
              {/* Actual Logo - Much bigger to match title */}
              <img 
                src="https://customer-assets.emergentagent.com/job_internal-health/artifacts/32a8oz2n_logo.jpeg"
                alt="Tri-City Internists Logo"
                className="h-40 w-40 object-contain"
              />
              <div className="hidden md:block">
                <h1 className="text-5xl font-bold leading-none" style={{color: 'var(--sage-dark)'}}>
                  Tri-City Internists
                </h1>
                <p className="text-3xl font-bold text-center mt-1" style={{color: 'var(--sage-dark)'}}>Internal Medicine</p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('providers')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Our Team
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('why-us')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Why Us
            </button>
            <button 
              onClick={() => scrollToSection('locations')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Locations
            </button>
            <button 
              onClick={() => scrollToSection('resources')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Resources
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 font-medium transition-colors hover:text-[#8b6f47]"
            >
              Contact
            </button>
          </nav>

          {/* Phone & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="tel:9897914100" 
              className="flex items-center space-x-2 font-semibold transition-colors"
              style={{color: 'var(--earth-accent)'}}
            >
              <Phone className="w-5 h-5" />
              <span>(989) 791-4100</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('providers')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Our Team
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('why-us')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Why Us
              </button>
              <button 
                onClick={() => scrollToSection('locations')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Locations
              </button>
              <button 
                onClick={() => scrollToSection('resources')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Resources
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 font-medium py-2 transition-colors hover:text-[#8b6f47]"
              >
                Contact
              </button>
              <div className="pt-3 border-t border-gray-200">
                <a 
                  href="tel:9897914100" 
                  className="flex items-center space-x-2 font-semibold py-2"
                  style={{color: 'var(--earth-accent)'}}
                >
                  <Phone className="w-5 h-5" />
                  <span>(989) 791-4100</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
